import {
  type ISourceEntity,
  ISourceEntityTypes,
  SourceEntityMigrationType,
} from '@principle-theorem/practice-migrations/interfaces';
import { SourceEntity } from '../../../source/source-entity';
import { Timezone, TypeGuard } from '@principle-theorem/shared';
import { isBoolean, isNumber, isString } from 'lodash';
import { BaseSourceEntity } from '../../../source/base-source-entity';

export const PATIENT_ALLERGY_OPTIONS_RESOURCE_TYPE = 'patientAllergyOptions';

export const PATIENT_ALLERGY_OPTIONS_SOURCE_ENTITY: ISourceEntity =
  SourceEntity.init({
    metadata: {
      label: 'Patient Allergy Options',
      description: '',
      idPrefix: PATIENT_ALLERGY_OPTIONS_RESOURCE_TYPE,
      migrationType: SourceEntityMigrationType.Automatic,
    },
  });

export interface ID4WAllergyOption {
  id: number;
  description: string;
  isActive: boolean;
}

function isD4WAllergyOption(
  item: unknown,
  logError: boolean
): item is ID4WAllergyOption {
  return TypeGuard.interface<ID4WAllergyOption>(
    {
      id: isNumber,
      description: isString,
      isActive: isBoolean,
    },
    logError
  )(item);
}

const PATIENT_ALLERGY_OPTIONS_SOURCE_QUERY = `
SELECT
  id,
  description,
  convert_to_boolean(is_active) AS is_active
FROM allergy
WHERE id IS NOT NULL`;

export type D4WPatientAllergyOptions = ISourceEntityTypes<
  ID4WAllergyOption,
  object,
  object
>;

export class PatientAllergyOptionsSourceEntity extends BaseSourceEntity<D4WPatientAllergyOptions> {
  sourceEntity = PATIENT_ALLERGY_OPTIONS_SOURCE_ENTITY;
  entityResourceType = PATIENT_ALLERGY_OPTIONS_RESOURCE_TYPE;
  sourceQuery = PATIENT_ALLERGY_OPTIONS_SOURCE_QUERY;
  verifySourceFn = isD4WAllergyOption;

  translate(_data: ID4WAllergyOption, _timezone: Timezone): object {
    return {};
  }

  getSourceRecordId(data: ID4WAllergyOption): number {
    return data.id;
  }

  getSourceLabel(record: ID4WAllergyOption): string {
    return `${record.id}-${record.description}`;
  }
}
